(function ($) {
  $(document).on('click', '[data-food-gallery-item]', function (e) {
    e.preventDefault();
    e.stopPropagation();

    var $el = $(this),
      picture = $el.data('picture') || '',
      caption = $el.data('caption') || '',
      message = `
          <div class="mp-food-gallery-item-lightbox">
            <div class="mp-food-gallery-item-lightbox__picture">
              <img src="${picture}">
            </div>
            <div class="mp-food-gallery-item-lightbox__caption">
              ${caption}
            </div>
          </div>
        `
    ;

    Drupal.showModal({
      message,
      className: 'mp-modal',
      size: null
    });

  });
})(jQuery);
